import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { LibraryService,Dropobj } from '../services/library.service';
import { map ,delay,debounceTime } from 'rxjs/operators';
import {debounce} from 'lodash';

@Component({
  selector: 'app-elinks',
  templateUrl: './elinks.component.html',
  styleUrls: ['./elinks.component.scss'],
  providers:[LibraryService],
})
export class ElinksComponent implements OnInit {

  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  tab=1;
  arrprvrtype=[{name:'Print'},{name:'online'},{name:'Both'}];

  arrsource=[{name:'Journal'},{name:'Conference'},{name:'Book'},{name:'Others'}];
  status = [
    {
      id: 1,
      name: 'Active'
    },
    {
      id: 2,
      name: 'Inactive'
    }
 ];
 arrresources=[];
 categorymodel:any={};
 selpub:any={};
 selsup:any={};
 selsub:any={};

 bookdetails:any[];
    depts:any[];
    catgories:any[];
    suppliers:any[];
    publishers:any[];
    sources:any[];
    subjects:any[];
    author: Dropobj[];
    uptype:any;
    acctypes: any[];
   
    private smallmodalRef: NgbModalRef;
    booksmodel:any={};
    pmodel:any={};
    questmodel:any={};
    dashcount:any={};
    bookinfo:any={};
    oprtype:string;
    filtcatgory:any[];
    bindtypes:any[];
    laguages:any[];
    currency:any[];
    lsection=[];
    issuehis=[];
    ebkid:any;
    arrcourse=[];
    arrclass=[];
    arrcourse1=[];
    arrclass1=[];
    qbdetails=[];
    fmodel:any={};
    arrstaff:any=[];
    arrstfpub:any=[];
 
    selcat:any=0;
    verifiedstatus:any;
    issuedetails:any={};
    bkcopies:any=1;
    showload:any="No";
    statuses = [
      {value: 'Active', label: 'Active'},
      {value: 'Inactive', label: 'Inactive'},
     
    
    ];

    arrestype = [
      {value: 'Open', label: 'Open'},
      {value: 'Subscribed', label: 'Subscribed'},
     
    
    ];

    arbktype = [
      {value: 'Ebook', label: 'Ebook'},
      {value: 'EMagazine', label: 'EMagazine'},
      {value: 'EJournal', label: 'EJournal'},
      {value: 'Other', label: 'Other'},
     
    
    ];
    fileToUpload: File = null;
    fData: FormData = new FormData;

    pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";

  constructor(private liservice: LibraryService,private modalService: NgbModal) { 

    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'lg'
    }
    this.savelibquestbank = debounce(this.savelibquestbank, 1000);
    this.savebookdetails = debounce(this.savebookdetails, 1000);
    this.SavecatDetails = debounce(this.SavecatDetails, 1000);
    this.fileupload = debounce(this.fileupload, 1000);
    this.fileuploadqbank = debounce(this.fileuploadqbank, 1000);
  }


  exportperiodical(){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.liservice.callurl+"export/expfacultypublished.php?clcd="+clcd+"&aycd="+aycd;
  
     window.open(url,'','_blank');
   }

  openpubmodal (content,formdata,cmd) {

this.getstaff();
    if(cmd=='insert')
    {
      this.pmodel={};
       this.pmodel.id='0';
       this.pmodel.oprtype='insert';
      //this.pmodel.emid='0';
      this.pmodel.stfdepnm='';
      this.pmodel.MOP='Both';
      this.pmodel.title='';
      this.pmodel.srccatnm='Journal';
      this.pmodel.volume='';
      this.pmodel.issueno='';
      this.pmodel.pyear='';
      this.pmodel.pmonth='';
      this.pmodel.pplace='';
      this.pmodel.issnno='';
      this.pmodel.DOI='';
      this.pmodel.pindex='';
      this.pmodel.sourcename='';
      this.pmodel.subnm='';
      this.pmodel.pubnm='';

      // this.booksmodel.publisher=this.selpub.pubid==undefined?0:this.selpub.pubid;
      // this.booksmodel.supid=this.selsup.supid==undefined?0:this.selsup.supid;
      // this.booksmodel.subjectid=this.selsub.subid==undefined?0:this.selsub.subid;

    }

    else if(cmd=='update')
    {
      this.pmodel=formdata;
     this.pmodel.oprtype='update';

    //  this.selpub.pubnm=formdata.pubnm;
    //  this.selpub.pubid=formdata.pubid;
 
     
 
    //  this.selsub.subnm=formdata.subnm;
    //  this.selsub.subid=formdata.subid;
    }
    
    this.modalOptions.size='lg';
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  savestaffpulished()
  {
//  this.pmodel.pubid=this.selpub.pubid==undefined?0:this.selpub.pubid;
//       // this.booksmodel.supid=this.selsup.supid==undefined?0:this.selsup.supid;
//        this.pmodel.subid=this.selsub.subid==undefined?0:this.selsub.subid;
    this.liservice.savestaffpublished(this.pmodel)
    .subscribe(
    result => {
        console.log('SavesourceDetails', result);
        //this.suppliers = resultArray;
        alert(result.message);
        if(result.status=='Success')
        {
          let localmodref=this.modalRef;
          localmodref.close();
          this.selpub={};
          this.selsub={};
          this.getstaffpuled();
          
         // this.getlibmperiodical('selwithsub');
         // this.get();
        }
     else  {

       }
    },
    error =>{ alert('Error While saving...');}
    )
  }
  


  openmodal (content,formdata,cmd) {


    if(cmd=='insert')
    {
      this.categorymodel={};
      this.categorymodel.resid=0;
      this.categorymodel.oprtype='insert';
      this.categorymodel.resdesc='';
      this.categorymodel.reslink='';
      this.categorymodel.recordstatus='Active';
      this.categorymodel.restype='Open';

    }

    else if(cmd=='update')
    {
      this.categorymodel=formdata;
      this.categorymodel.oprtype='update';
    }
    
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
  
 
  ngOnInit(): void {
    //this.getlibresources();
    this.fmodel.crsid='0';
    this.fmodel.semid='0';
    this.getbookdetails();
    this.getlibebookdash();
   
    this.getlibdepartment();
    this.getlibpublisher();
   
    this.getlibsubjects();
   
   
    this.getgenmasters('Language');
    this.getcourses();
    this.getclases();
  }
  getlibresources() {
    this.liservice.getlibresources()
        .subscribe(
        resultArray => {
            console.log('getlibresources', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrresources = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  getstaffpuled() {
    this.liservice.getstaffpublished()
        .subscribe(
        resultArray => {
            console.log('getlibresources', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrstfpub = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  getstaff() {
    this.liservice.getstafflist()
        .subscribe(
        resultArray => {
            console.log('getlibresources', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrstaff = resultArray.filter(o=>{

              return o.statush=='Active';
            });

           
           
        },
        error => console.log("Error :: " + error)
        )
  }

  serlibpublisher(sertxt) {
    this.liservice.serlibpublisher("selforbookser",sertxt)
        .subscribe(
        resultArray => {
            console.log('serlibpublisher', resultArray);
            this.publishers = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }

  onpubChangeSearch(sertxt) {
    debugger
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
    if(sertxt.query.length>=3) 
    {
      this.serlibpublisher(sertxt.query);
    }
  }

  serlibsubjects(sertxt) {
    this.liservice.serlibsubjects('serforbook',sertxt)
        .subscribe(
        resultArray => {
            console.log('getlibsubjects', resultArray);
            this.subjects = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  onsubChangeSearch(sertxt) {
    debugger
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
    if(sertxt.query.length>=3) 
    {
      this.serlibsubjects(sertxt.query);
    }
  }

  SavecatDetails()
  {
console.log('catsave',this.categorymodel);
    this.liservice.savelibresources(this.categorymodel)
        .subscribe(
        result => {
            console.log('savelibcategory', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getlibresources();

            }
           else
           {

           }
        },
        error =>{ alert('Error While saving...');}
        )
  }

  onpubselectEvent(item) {
    //alert('hi');
        console.log('item',item);
        //this.selmember=item;
        //this.getissuedbookinfocnts(item.id);
      //  this.getissueddetails();
        // do something with selected item
      }
  savebookdetails()
  {


    console.log('savedetails',this.booksmodel);
    this.liservice.savelibebook(this.booksmodel,this.oprtype)
.subscribe(result => {
   alert(result.message);
   
if(result.status=='Success')
{
  let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.getbookdetails();

}


else{


}
   

  
    
}, error => alert('error in connection')
);
  }

  savelibquestbank()
  {


    console.log('i',this.questmodel);
    this.liservice. savelibquestbank(this.questmodel,this.oprtype).pipe(debounceTime(500))
.subscribe(result => {
   alert(result.message);
   
if(result.status=='Success')
{
  let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.getqbdetails();

}


else{


}
   

  
    
}, error => alert('error in connection')
);
  }

  getqbdetails() {
    this.liservice.getlibquestbank(this.fmodel)
        .subscribe(
        resultArray => {
            console.log('books-result', resultArray);
            this.qbdetails = resultArray;
           // this.authorfilter();
          //   this.author  = resultArray [
          //     {'author'}
          // ];
        },
        error => console.log("Error :: " + error)
        )
}
 
  getbookdetails() {
    this.liservice.getlibebooks()
        .subscribe(
        resultArray => {
            console.log('books-result', resultArray);
            this.bookdetails = resultArray;
           // this.authorfilter();
          //   this.author  = resultArray [
          //     {'author'}
          // ];
        },
        error => console.log("Error :: " + error)
        )
}

getlibebookdash() {
  this.liservice.getlibebookdash()
      .subscribe(
      resultArray => {
          console.log('books-result', resultArray);
          this.dashcount = resultArray;
         // this.authorfilter();
        //   this.author  = resultArray [
        //     {'author'}
        // ];
      },
      error => console.log("Error :: " + error)
      )
}

getdashcounts() {
  this.liservice.booksdashcounts()
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.dashcount = resultArray[0];
         
      },
      error => console.log("Error :: " + error)
      )
}

getgenmasters(mastype) {
  //de
  var resuarr=[];
return  this.liservice.getgenmasters(mastype)
      .subscribe(
      resultArray => {
          console.log('getgenmasters', resultArray);
          if(mastype=='Bindingtype')
          {
          this.bindtypes = resultArray;
          }
         else if(mastype=='Language')
          {
          this.laguages = resultArray;
          if (resultArray.length>0)
          {
          this.booksmodel.languageid=resultArray[0].id;
          }
          else
          {
            this.booksmodel.languageid='0';
          }
          }
         else if(mastype=='Currency')
          {
          this.currency = resultArray;
          if (resultArray.length>0)
          {
          this.booksmodel.currencyid=resultArray[0].id;
          }
          else
          {
            this.booksmodel.currencyid='0';
          }
          }
         
      },
      error => console.log("Error :: " + error)
      )
     
}

private getcourses() {

  var objpush={crid:'0',crnm:'ALL'};
  this.liservice.getcourse()
.subscribe((result:any) => {

this.arrcourse=result;

this.arrcourse1=result;

this.arrcourse1.splice(0,0,objpush);



}, error => {

//alert('error in r');
// this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
}
);
  
  
}

private getclases() {
  var objpush={clid:'0',clnm:'ALL'};
  this.liservice.getlibclasses()
.subscribe((result:any) => {

this.arrclass=result;

this.arrclass1=result;

this.arrclass1.splice(0,0,objpush);

}, error => {


}
);




}

getlibsubjects() {
  this.liservice.getlibsubjects()
      .subscribe(
      resultArray => {
          console.log('getlibsubjects', resultArray);
          this.subjects = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}



composefiltercategory(jstring)
{
  var newstr = jstring.replace(/bkcatid/g, "value"); 
  var newstr = newstr.replace(/bkcatnm/g, "label"); 
  console.log('jsonrep',newstr);
  let resJSON = JSON.parse(newstr);
  var arr=Array.of(resJSON);
  let objval:any={};
  objval.label='All';
  objval.value='0';
  objval.status=0;
  arr[0].splice(0, 0, objval);
  this.filtcatgory=arr[0];
  console.log('filtcatgory',this.filtcatgory);
}
onChangefiltcat(selval)
{
debugger;
  //alert(selval);
this.selcat=selval;
}

getlibpublisher() {
  this.liservice.getlibpublisher("selall")
      .subscribe(
      resultArray => {
          console.log('getlibpublisher', resultArray);
          this.publishers = resultArray;
          
      },
      error => console.log("Error :: " + error)
      )
}
getlibdepartment() {
  this.liservice.getlibdepartment()
      .subscribe(
      resultArray => {
          console.log('getlibdepartment', resultArray);
          this.depts = resultArray;
          
      },
      error => console.log("Error :: " + error)
      )
}


handleFileInput(files: FileList)
{
    //console.log(e);
    this.fileToUpload = files.item(0);
}

upload(files: FileList) {
  debugger;
  this.fileToUpload = files.item(0);

  this.fData.append("bkid", this.ebkid.toString());
  this.fData.append("qbid", this.ebkid.toString());
  
}


fileupload()
{
debugger
this.showload="Yes";
console.log('file data',JSON.stringify(this.fileToUpload));

this.liservice.uploadebookFile(this.fileToUpload,this.ebkid)
.subscribe(fresult => {
   // console.log('ret',JSON.stringify(fresult));
    alert (fresult.message);
    this.showload="No";
    if(fresult.status=='Success')
{
let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.fileToUpload=null;
}
    
}, error => 
{
alert('error in connection');
this.showload="No";
}

);



}


fileuploadqbank()
{
debugger

console.log('file data',JSON.stringify(this.fileToUpload));
this.showload="Yes";

this.liservice.uploadquestbank(this.fileToUpload,this.ebkid)
.subscribe(fresult => {
   // console.log('ret',JSON.stringify(fresult));
    alert (fresult.message);
    this.showload="No";
    if(fresult.status=='Success')
{
let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.fileToUpload=null;
}
    
}, error => 
{
alert('error in connection');
this.showload="No";
}

);



}



fileuploadstaffpaper()
{
debugger

console.log('file data',JSON.stringify(this.fileToUpload));
this.showload="Yes";

this.liservice.uploadstfpaper(this.fileToUpload,this.ebkid)
.subscribe(fresult => {
   // console.log('ret',JSON.stringify(fresult));
    alert (fresult.message);
    this.showload="No";
    if(fresult.status=='Success')
{
let localmodref=this.modalRef;
localmodref.close();
//this.Refreshsummary();
this.fileToUpload=null;
}
    
}, error => 
{
alert('error in connection');
this.showload="No";
}

);



}
//   OnSubmit(Image) {
// //var enid=this.enid+'-'+this.orderid+'-'+this.cldata.dbname;
//      // this.myservice.uploadImage(enid,this.fileToUpload,this.secdoctypeid,this.cldata.schoolcode)
// .subscribe((result:any) => {


// }, error => {
// console.log('enqres',error);
// alert('error in connection')}
// );
    
//     }
authorfilter()
{
var autharr=this.bookdetails;
  // this.author = autharr.filter(
  //   (thing, i, arr) => arr.findIndex(t => t.author === thing.author) === i
  // );
  var farr= Array.from(new Set(autharr.map((item: any) => item.author)));
 
  var auth=[];
  for(var i=0;i<farr.length;i++)
  {
    debugger
     let objval:Dropobj;
objval.label=farr[i]
objval.value=farr[i];
console.log('obj',objval);
auth.push(objval);
  }
this.author=auth;
  console.log('auths',auth);
//   this.statuses = [
//     {label: 'Unqualified', value: 'unqualified'},
//     {label: 'Qualified', value: 'qualified'},
//     {label: 'New', value: 'new'},
//     {label: 'Negotiation', value: 'negotiation'},
//     {label: 'Renewal', value: 'renewal'},
//     {label: 'Proposal', value: 'proposal'}
// ]

}
applybooksFilter(filterValue: string) {
  filterValue = filterValue.trim(); // Remove whitespace
  filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches

  if(filterValue.length>=3)
  {
    debugger
    
  this.liservice.serchbooks(filterValue,'serebook',0)
  .subscribe(
  resultArray => {
      console.log('books-result', resultArray);
      this.bookdetails = resultArray;
    // this.authorfilter();
      
  },
  error => console.log("Error :: " + error)
  )
}
else 
{
  this.getbookdetails();
}

}

openinfo(content,bkid,uptype)
{
this.uptype=uptype;
  this.ebkid=bkid;
  this.modalOptions={size:'sm'};
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}

openlink(url){
  

   window.open(url,'','_blank');
 }

viewpdf(content,bkid)
{

  this.pdfSrc=this.liservice.pdfurl+bkid;
  this.modalOptions={size:'lg'};
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}

downloadqbpaper(qbpath,title)
{

  var pdfSrc=this.liservice.pdfurl+qbpath;
  //var pdfSrc="http://43.247.158.94:8081/mycampuz/api/questbank/112/62.pdf";
  //http://localhost:4200/api/questbank/112/62.pdf

  this.liservice.getqbblob(pdfSrc,title)
  .subscribe(res => {
    //console.log('start download:',res);
    var url = window.URL.createObjectURL(res.data);
    
    var a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = res.filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove(); // remove the element
  }, error => {
    //console.log('download error:', JSON.stringify(error));
  }, () => {
    //console.log('Completed file download.')
  });
  
}

openquestbank(content,formdata,cmd) {
  debugger
  console.log("formdata",formdata);
  this.modalOptions={size:'lg'};
  this.oprtype=cmd;
  this.questmodel.oprtype=cmd;
  this.getlibsubjects();

  if(cmd=='insert')
  {
    this.questmodel={};
    
   
    this.questmodel.qbid=0;
   
    
    this.questmodel.qbtitle='';
   
    this.questmodel.subid='1';
    
    
    this.questmodel.crsid='1';
    
    this.questmodel.semid='1';
    this.questmodel.oprtype=cmd;
    
   


    this.modalRef=this.modalService.open(content,this.modalOptions);
  
   this.modalRef.result.then((result) => {
  
        // this.Asmtdetls(asid);
         this.closeResult = `Closed with: ${result}`;
     }, (reason) => {
         this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     });
  }
  else if (cmd=='update')
  {
    
    this.questmodel=formdata;
    this.questmodel.oprtype=cmd;
    this.modalRef=this.modalService.open(content,this.modalOptions);
  
   this.modalRef.result.then((result) => {
  
        // this.Asmtdetls(asid);
         this.closeResult = `Closed with: ${result}`;
     }, (reason) => {
         this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     });

  }
  
  
    
  

}
openbookdialog(content,formdata,cmd) {
  debugger
  console.log("formdata",formdata);
  this.modalOptions={size:'lg'};
  this.oprtype=cmd;
  if(cmd=='insert')
  {
    this.booksmodel={};
    if (this.laguages.length>0)
    {
    this.booksmodel.languageid=this.laguages[0].id;
    }
    else
    {
      this.booksmodel.languageid='0';
    }
   
    this.booksmodel.ebkid=0;
   
    
    this.booksmodel.rstatus='Active';
  
    this.booksmodel.publisher='1';
    
    this.booksmodel.deptid='1';
   
    this.booksmodel.subjectid='1';
    
    
    this.booksmodel.author='';
    
    this.booksmodel.pubplace='';
    this.booksmodel.pubyr='';
    this.booksmodel.pages='0';
    this.booksmodel.edition='';
   
    this.booksmodel.title='';
    this.booksmodel.subtitle='';
    this.booksmodel.bktype='Ebook';
   


    this.modalRef=this.modalService.open(content,this.modalOptions);
  
   this.modalRef.result.then((result) => {
  
        // this.Asmtdetls(asid);
         this.closeResult = `Closed with: ${result}`;
     }, (reason) => {
         this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     });
  }
  else if (cmd=='update')
  {
    if(formdata.rstatus=='Active')
{
    this.booksmodel=formdata;
    this.modalRef=this.modalService.open(content,this.modalOptions);
  
   this.modalRef.result.then((result) => {
  
        // this.Asmtdetls(asid);
         this.closeResult = `Closed with: ${result}`;
     }, (reason) => {
         this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     });
}
  }
  
  
    
  

}
private getDismissReason(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
    return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    return 'by clicking on a backdrop';
  } else {
    return  `with: ${reason}`;
  }
}

}
